import { ReactComponent as Logo } from 'assets/images/vin2_logo.svg';

/**
 * @param {React.SVGProps<SVGSVGElement> & { title?: string }} props
 * @returns {JSX.Element}
 */
export function AppLogo(props) {
  return <Logo title="vin2 logo" height={64} {...props} />;
}
